"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithPopUpQueueUtils = exports.PopUpQueueContext = void 0;
var react_1 = __importStar(require("react"));
var config_1 = require("./config");
var navigation_1 = require("next/navigation");
var apps_shared_1 = require("@l2p/apps-shared");
exports.PopUpQueueContext = react_1.default.createContext({
    addPopupToQueue: function () { },
});
var MODAL = 'modal';
var usePopUpQueue = function () {
    var _a = (0, react_1.useState)([]), queue = _a[0], setQueue = _a[1];
    var searchParams = (0, navigation_1.useSearchParams)();
    var prevModal = (0, react_1.useRef)(null);
    var openModal = (0, apps_shared_1.useOpenModal)();
    var checkHashInQueue = (0, react_1.useCallback)(function (hash) { return queue && queue.find(function (record) { return (record === null || record === void 0 ? void 0 : record.name) === hash; }); }, [queue]);
    var checkIsPopUpEnabled = (0, react_1.useCallback)(function (name) {
        return !!config_1.modalConfig.find(function (record) { return record.name === name && record.enabled; });
    }, []);
    var addPopupToQueue = (0, react_1.useCallback)(function (name) {
        var _a;
        if (!checkHashInQueue(name) && checkIsPopUpEnabled(name)) {
            var priority = ((_a = config_1.modalConfig.find(function (record) { return record.name === name; })) === null || _a === void 0 ? void 0 : _a.priority) || 1;
            var queueCopy = __spreadArray([], queue, true);
            queueCopy.push({ name: name, priority: priority });
            // The first element shouldn't be sorted
            var currentElement = queueCopy.splice(0, 1);
            queueCopy.sort(function (a, b) { return b.priority - a.priority; });
            setQueue(__spreadArray(__spreadArray([], currentElement, true), queueCopy, true));
        }
    }, [queue, setQueue, checkHashInQueue, checkIsPopUpEnabled]);
    var removeFromQueue = (0, react_1.useCallback)(function () {
        if (queue.length === 0)
            return;
        var queueCopy = __spreadArray([], queue, true);
        queueCopy.shift();
        setQueue(queueCopy);
    }, [setQueue, queue]);
    var pushPopUp = (0, react_1.useCallback)(function () {
        if (queue && queue.length > 0) {
            openModal(queue[0].name);
        }
    }, [openModal, queue]);
    (0, react_1.useEffect)(function () {
        var currentModal = searchParams.get(MODAL);
        if (!currentModal && queue.length > 0 && !prevModal.current)
            pushPopUp();
        if (!prevModal.current && currentModal)
            prevModal.current = currentModal;
        if (prevModal.current && !currentModal) {
            removeFromQueue();
            prevModal.current = null;
        }
    }, [removeFromQueue, searchParams, pushPopUp, queue]);
    return {
        addPopupToQueue: addPopupToQueue,
    };
};
var WithPopUpQueueUtils = function (_a) {
    var children = _a.children;
    var utils = usePopUpQueue();
    return (react_1.default.createElement(exports.PopUpQueueContext.Provider, { value: utils }, children));
};
exports.WithPopUpQueueUtils = WithPopUpQueueUtils;
exports.default = react_1.default.memo(exports.WithPopUpQueueUtils);
